"use client";

import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import clsxm from "@/lib/clsxm";
import {type ComponentPropsWithoutRef, type FC, type RefObject} from "react";

const ScrollArea: FC<
  ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
    ref?: RefObject<HTMLDivElement>;
    viewportClassName?: string;
  }
> = ({ref, className, viewportClassName, children, ...props}) => (
  <ScrollAreaPrimitive.Root ref={ref} className={clsxm("relative overflow-hidden", className)} {...props}>
    <ScrollAreaPrimitive.Viewport className={clsxm("size-full rounded-[inherit]", viewportClassName)}>
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollBar />
    <ScrollAreaPrimitive.Corner />
  </ScrollAreaPrimitive.Root>
);
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar: FC<
  ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar> & {ref?: RefObject<HTMLDivElement>}
> = ({ref, className, orientation = "vertical", ...props}) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={clsxm(
      "flex touch-none transition-colors select-none",
      orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-px",
      orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px",
      className,
    )}
    {...props}>
    <ScrollAreaPrimitive.ScrollAreaThumb className="bg-border relative flex-1 rounded-full" />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
);
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export {ScrollArea, ScrollBar};
